import { AfterContentChecked, AfterViewInit, Component, ErrorHandler, Inject, OnInit, ViewChild, ChangeDetectionStrategy, Injector, inject, signal } from '@angular/core'
import { disabled, FieldTree, form, required } from '@angular/forms/signals'

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatInput } from '@angular/material/input'

import { arvonMuutokset, asetaArvo } from '../../_jaettu-angular/_lomakkeet/arvon-muutokset'
import { FieldErrors, FormValidationService } from '../../_jaettu-angular/service/form-validation.service'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'

import { Lasku, LaskuBase, LaskuReskontra } from '@lemon/core-firebase/model/lasku'
import { LaskuSharedService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { Kirjanpitaja } from 'app/_jaettu-lemonator/model/kirjanpitaja'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

interface OsasuoritusLomake {
  avoinna: number
  maksettuMaara: number | null
  avoimeksijaa: number
}

export interface LaskuMerkitseOsittainMaksetuksiLemonatorDialogData {
  juurilasku: Lasku
  kasiteltava: LaskuBase
  reskontra: LaskuReskontra[]
  kirjanpitaja: Kirjanpitaja
}

@Component({
  selector: 'lasku-merkitse-osittain-maksetuksi-dialog-lemonator',
  templateUrl: './lasku-merkitse-osittain-maksetuksi-lemonator.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuMerkitseOsittainMaksetuksiLemonatorDialog implements OnInit, AfterViewInit, AfterContentChecked {
  @ViewChild('maksettuMaaraInput', { read: MatInput, static: true }) maksettuMaaraInput: MatInput

  lomake: FieldTree<OsasuoritusLomake>
  fieldErrors: FieldErrors = {}
  kasiteltava: LaskuBase = null

  maksettuMaara: number = 0
  avoinna: number = 0

  private _buttonPushInflight: boolean = false
  private readonly _injector = inject(Injector)

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LaskuMerkitseOsittainMaksetuksiLemonatorDialogData,
    private errorHandler: ErrorHandler,
    private dialogRef: MatDialogRef<LaskuMerkitseOsittainMaksetuksiLemonatorDialog>,
    private validationService: FormValidationService,
    private laskuService: LaskuService,
    private sharedLaskuService: LaskuSharedService,
    private currencyService: CurrencyService,
    private ladataanService: LadataanService,
  ) {
    this.kasiteltava = data.kasiteltava
    const summatJaTila = this.sharedLaskuService.annaLaskunSummatJaTilaLaskulleReskontralla(data.juurilasku, data.reskontra)
    this.avoinna = this.currencyService.muutaBigDecimalRahaksi(summatJaTila.avoinna)
    this.maksettuMaara = this.avoinna
  }

  ngAfterContentChecked() {
    this.fieldErrors = this.validationService.updateValidationStatus('lasku.merkitse-osittain-maksetuksi', this.lomake)
  }

  ngOnInit() {
    this.lomake = form(
      signal<OsasuoritusLomake>({ avoinna: this.avoinna, maksettuMaara: this.maksettuMaara, avoimeksijaa: 0 }),
      polku => {
        required(polku.avoinna)
        disabled(polku.avoinna)
        required(polku.maksettuMaara)
        required(polku.avoimeksijaa)
        disabled(polku.avoimeksijaa)
      },
      { injector: this._injector },
    )

    arvonMuutokset(this.lomake.maksettuMaara, { injector: this._injector }).subscribe(value => {
      this.maksettuMaara = value
      asetaArvo(this.lomake.avoimeksijaa, this.avoinna - this.maksettuMaara)
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.maksettuMaaraInput) {
        this.maksettuMaaraInput.focus()
      }
    }, 25)
  }

  async lisaaMaksettuaSummaa() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    this.ladataanService.aloitaLataaminen()
    try {
      await this.laskuService.lisaaReskontraMerkinta(this.data.juurilasku, this.maksettuMaara, this.data.kirjanpitaja)
      this.dialogRef.close()
    } catch (error) {
      this.errorHandler.handleError(error)
    } finally {
      this.ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }
}
